import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ConsentFormComponent } from './consent-form/consent-form.component';
import { CommonTermsComponent } from './common-terms/common-terms.component';
import { AgreementComponent } from './agreement/agreement.component';
import { MatSliderModule } from '@angular/material/slider';
import { IframeTllaComponent } from '../financing-flow/iframe-tila/iframe-tila.component';
@NgModule({
  declarations: [ConsentFormComponent, CommonTermsComponent, AgreementComponent, IframeTllaComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatSliderModule,
  ]
})
export class MiscModule { }
